import { render, staticRenderFns } from "./draw_record.vue?vue&type=template&id=264f4003&scoped=true"
import script from "./draw_record.vue?vue&type=script&lang=js"
export * from "./draw_record.vue?vue&type=script&lang=js"
import style0 from "./draw_record.vue?vue&type=style&index=0&id=264f4003&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f4003",
  null
  
)

export default component.exports